export default __webpack_public_path__ + "6ca4ae22f083ff3a6ca2dbaa22049d37.png";